import { useState, useEffect } from "react";
import { FLEX_COL_FILL } from "../../../../../themes/sbux/components";
import { Box } from "@mui/material";
import SbuxEnhancedTable from "../../../../../components/SbuxTable/SbuxEnhancedTable";
import EditFeatureFlagsRow from "./EditFeatureFlagsRow";
import { columns } from "./columns";
import type { FeatureFlag } from "../../../../../slices/featureFlagsSlice";

interface Props {
  featureFlags: FeatureFlag[];
  handleRefrehClick: () => void;
}

const FeatureFlagsTable = ({ featureFlags, handleRefrehClick }: Props) => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 100);
  }, []);

  return (
    <Box sx={FLEX_COL_FILL}>
      <SbuxEnhancedTable
        rows={featureFlags}
        columns={columns}
        defaultSortingField={"name"}
        defaultSortOrder={"asc"}
        RowSource={EditFeatureFlagsRow}
        showFooter={true}
        showSearchBar={false}
        isManager={true}
        handleRefreshClick={handleRefrehClick}
        isLoading={isLoading}
        footerMarginBottom="0"
      />
    </Box>
  );
};

export default FeatureFlagsTable;
